import React from 'react'
import ManageContent from './ManageContent'

export default function ManagePage () {
  return (
    <div className='helpPage web'>
      <ManageContent />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/manage/ManagePage.jsx